/* Dansk katalog for locale-payroll-runs-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'pay.salaryTypeSaved': 'Løntype gemt.',
  'pay.salaryTypeSaveFailed': 'Kunne ikke gemme løntype.',
  'pay.fixedLineSaved': 'Fast lønlinje gemt.',
  'pay.fixedLineSaveFailed': 'Kunne ikke gemme fast lønlinje.',
  'pay.fillNameAndAccountNumber': 'Udfyld navn og kontonummer.',
  'pay.accountAdded': 'Konto tilføjet.',
  'pay.addAccountFailed': 'Kunne ikke tilføje konto.',
  'pay.calculationCodeNotSupported': 'Denne beregningskode for arbejdsgiverafgift understøttes ikke endnu. Vælg Generelle erhverv.',
  'pay.payrollSettingsSaved': 'Lønindstillinger gemt.',
  'pay.payrollSettingsSavedWithRecalc': 'Lønindstillinger gemt. {count} åbne lønkladder er genberegnet.',
  'pay.payrollSettingsSaveFailed': 'Kunne ikke gemme lønindstillinger.',
  'pay.markedManualSubmission': 'Markeret som manuel indsendelse.',
  'pay.ameldingSentToAltinn': 'A-melding sendt til Altinn.',
  'pay.payslipsCreatedAndPosted': 'Lønsedler oprettet og løn bogført. Lønsedlerne kan sendes senere.',
  'pay.payrollRunEditableAgain': 'Lønudbetalingen kan ændres igen.',
  'pay.accountingAnnulled': 'Bogføringen er annulleret.',
  'pay.payrollRunAnnulled': 'Lønudbetaling annulleret.',
  'pay.payoutRegistered': 'Udbetaling registreret.',
  'pay.confirmAnnulPayment': 'Annullere denne betaling? Posteringen tilbageføres, ved at betalingen ikke længere medtages.',
  'pay.hideDeletedPayrollRuns': 'Skjul slettede lønudbetalinger',
  'pay.showDeletedPayrollRuns': 'Vis slettede lønudbetalinger ({count})',
  'pay.removePermanently': 'Fjern permanent',
  'pay.removeDeletedPayrollRunPermanently': 'Fjern slettet lønudbetaling permanent',
  'pay.confirmRemoveDeletedPayrollRunTitle': 'Fjerne slettet lønudbetaling?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'Dette fjerner kladden for {period} permanent. Kun løn, der aldrig er godkendt, sendt eller bogført, kan fjernes her.',
  'pay.editPaymentTitle': 'Redigér betaling',
  'pay.registerPaymentTitle': 'Registrér betaling',
  'pay.savingEllipsis': 'Gemmer...',
  'pay.savePaymentAction': 'Gem betaling',
  'pay.editSalaryTypeTitle': 'Redigér løntype',
  'pay.newFixedLineTitle': 'Ny fast lønlinje',
  'pay.editFixedLineTitle': 'Redigér fast lønlinje',
  'pay.operatingAccount': 'Driftskonto',
  'pay.newWithholdingAccountTitle': 'Ny skattetrækskonto',
  'pay.newPayrollAccountTitle': 'Ny lønkonto',
  'pay.addAccountAction': 'Tilføj konto',
  'pay.totalPay': 'Samlet løn',
  'pay.taxDeduction': 'Skattetræk',
  'pay.voucher': 'Bilag',
  'pay.basis': 'Grundlag',
  'pay.payrollRuns': 'Lønkørsler',
  'pay.agaOfHolidayPayFull': 'AGA af feriepenge',
  'pay.deadline': 'Frist',
  'pay.paidAmount': 'Betalt',
  'pay.remaining': 'Tilbage',
  'pay.provider': 'Leverandør',
  'pay.orgNumber': 'Org.nr.',
  'pay.earnedAtStandardRate': 'Optjent (10,2 %)',
  'pay.ameldingRegistered': 'A-melding registreret',
  'pay.noSubmissions': 'Ingen indsendelser',
  'pay.posted': 'Bogført',
  'pay.notPosted': 'Ikke bogført',
  'pay.payslipsNotGenerated': 'Lønsedler er ikke genereret.',
  'pay.employmentSetOnEmployeePage': 'Ansættelsesforhold angives på medarbejdersiden',
  'pay.rulesFromSalaryType': 'Regler fra løntypen',
  'pay.useStandardRules': 'Brug standardreglerne',
  'pay.advancedSettings': 'Avancerede indstillinger',
  'pay.overrideCanChangeCalculation': 'Tilsidesættelse kan ændre skat, arbejdsgiverafgift, feriepenge, OTP og bogføring for denne linje.',
  'pay.removeFromFixedLines': 'Fjern denne fra faste lønlinjer',
  'pay.makeThisAFixedLine': 'Gør denne til en fast lønlinje',
  'pay.withholdingExceedsCashPayWarning': 'Skattetrækket er højere end kontantløn og refusioner. Tilføj kontantløn, eller reducér trækket, før lønkørslen kan godkendes.',
  'pay.attachDocumentationHint': 'Vedhæft dokumentation for lønudbetalingen, for eksempel timesedler eller manuelle rejseafregninger.',
  'pay.upload': 'Upload',
  'pay.step1AltinnHelp': 'Når alle linjer er med, er næste trin at indberette lønudbetalingen. Altinn-integrationen kobles på senere, så meldingen kan markeres som manuel indsendelse nu.',
  'pay.step3PayslipsHelp': 'Når lønudbetalingen er indberettet og godkendt, oprettes lønsedler, og lønnen bogføres.',
  'pay.step4PaymentHelp': 'Registrér og bogfør udbetaling af løn til medarbejdere og skattetræk til Skatteetaten.',
  'pay.payrollRunCompletesWhenPaid': 'Lønudbetalingen afsluttes, når betalingen er registreret.',
  'pay.productionSupportedProfile': 'Profil understøttet i produktion: norsk løn, månedsperiode, Generelle erhverv og procentkort. Tabelkort, særlige AGA-koder og elektronisk indsendelse uden kvittering er blokeret.',
  'pay.searchMunicipalityOrNumber': 'Søg kommune eller nummer',
  'pay.notSupportedYet': 'understøttes ikke endnu',
  'pay.chooseGeneralIndustriesWarning': 'Vælg Generelle erhverv, før indstillingerne kan gemmes. Den tidligere valgte beregningskode er ikke implementeret.',
  'pay.searchProvider': 'Søg leverandør',
  'pay.month.may': 'Maj',
  'pay.payTypeNotFixedLine': 'Denne løntype kan ikke bruges som fast lønlinje.',
  'pay.calculationCodeUnsupportedShort': 'Denne beregningskode for arbejdsgiverafgift understøttes ikke endnu.',
  'pay.overtimePay': 'Overarbejde',
  'pay.mileageAllowance': 'Kørselsgodtgørelse',
  'pay.driveFallback': 'Kørsel',
  'pay.taxableMileagePortion': 'Skattepligtig del',
  'pay.expenseCategoryOther': 'Andet',
  'pay.overnightStayFallback': 'Overnatning',
  'pay.hotelFallback': 'Hotel',
  'pay.mileagePayoutFallback': 'Kørselsgodtgørelse',
  'pay.ownCar': 'Egen bil',
  'pay.travelPurposeFallback': 'Rejse',
  'pay.taxTermWithholdingLabel': 'Skattetræk {{date}}',
  'pay.taxTermAgaLabel': '{{term}}. termin',
  'pay.payrollRunNotEditableForNewLines': 'En godkendt lønkørsel kan ikke få nye lønlinjer.',
  'pay.payTypeNotManualEntry': 'Denne løntype kan ikke tilføjes manuelt.',
  'pay.receiptInboxFallbackName': 'Bilag fra indbakke',
  'pay.approvedButPayslipsFailed': 'Lønnen er bogført, men lønsedlerne blev ikke sendt: {{error}}',
  'pay.recon.runLabelPeriod': 'Løn {{period}}',
  'pay.recon.runLabelRun': 'Kørsel {{date}}',
  'pay.recon.notPaid': 'Ikke udbetalt',
  'pay.recon.paidAfterPeriod': 'Udbetalt efter periodedato',
  'pay.recon.flag.negativ_netto': 'Negativ nettoløn',
  'pay.recon.flag.mangler_skattekort': 'Mangler skattekort',
  'pay.recon.flag.sluttet_ansatt': 'Udbetaling til fratrådt medarbejder',
  'pay.recon.flag.naturalytelse': 'Personalegode til kontrol',
  'pay.recon.flag.uvanlig_endring': 'Unormal lønændring',
  'pay.recon.flag.mangler_amelding': 'Mangler i A-melding',
  'pay.recon.flag.mulig_duplikat': 'Mulig dobbeltudbetaling',
  'pay.recon.flag.ikke_utbetalt': 'Ikke udbetalt',
  'pay.recon.unknownEmployee': 'Ukendt medarbejder',
  'pay.recon.employmentTypeFixed': 'Fast',
  'pay.recon.reported': 'Indberettet',
  'pay.recon.notReported': 'Ikke indberettet',
  'pay.recon.afterPeriodDate': 'Efter periodedato',
  'pay.recon.role.forskuddstrekk': 'Skattetræk i perioden',
  'pay.recon.role.aga': 'Beregnet arbejdsgiverafgift af løn',
  'pay.recon.role.aga_feriepenger': 'Beregnet arbejdsgiverafgift af feriepenge',
  'pay.recon.role.feriepenger': 'Feriepengeforpligtelse ifølge lønsystemet',
  'pay.recon.role.skyldig_lonn': 'Nettoløn og træk fra lønsystemet',
  'pay.recon.role.pensjon': 'Pensionspræmie fra lønsystemet',
  'pay.recon.row.brutto': 'Bruttoløn',
  'pay.recon.row.naturalytelser': 'Skattepligtige personalegoder',
  'pay.recon.row.trekkpliktige': 'Trækpligtige ydelser',
  'pay.recon.row.godtgjorelser': 'Udgiftsgodtgørelser',
  'pay.recon.row.aga_grunnlag': 'Grundlag for arbejdsgiverafgift',
  'pay.recon.row.aga': 'Beregnet arbejdsgiverafgift',
  'pay.recon.row.netto': 'Nettoløn',
  'pay.recon.row.andre_trekk': 'Andre træk',
  'pay.recon.row.feriepenger': 'Optjente feriepenge',
  'pay.recon.row.pensjon': 'Pensionspræmie',
  'pay.recon.source.payrollSystem': 'Lønsystem',
  'pay.recon.source.bankPayouts': 'Bankudbetalinger',
  'pay.recon.source.pensionBasis': 'Pensionsgrundlag',
  'pay.recon.source.payrollSystemDetailSingular': '{{count}} bogført kørsel i perioden',
  'pay.recon.source.payrollSystemDetailPlural': '{{count}} bogførte kørsler i perioden',
  'pay.recon.source.payrollSystemDetailEmpty': 'Ingen bogførte lønkørsler i perioden',
  'pay.recon.source.ledgerDetail': '{{count}} posteringer på lønkontiene',
  'pay.recon.source.ledgerDetailEmpty': 'Ingen posteringer på de konti, der er tilføjet lønområdet',
  'pay.recon.source.ameldingDetailNone': 'Ingen kørsler at indberette',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} af {{total}} kørsler er registreret som indberettet',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} af {{total}} kørsler er ikke registreret som indberettet',
  'pay.recon.source.bankDetailNone': 'Ingen kørsler at betale',
  'pay.recon.source.bankDetailPaid': '{{paid}} af {{total}} kørsler er registreret som udbetalt',
  'pay.recon.source.pensionDetailPresent': 'Pensionspræmie beregnet af lønsystemet',
  'pay.recon.source.pensionDetailNone': 'Ingen pensionspræmie i perioden',
  'pay.recon.check.bokfort': 'Alle lønkørsler er bogført',
  'pay.recon.check.hovedbok': 'Lønsystemet stemmer med hovedbogen',
  'pay.recon.check.kontrollkontoer': 'Kontrolkontiene stemmer med grundlaget',
  'pay.recon.check.bank': 'Nettolønnen er udbetalt',
  'pay.recon.check.amelding': 'A-melding er registreret som indsendt',
  'pay.recon.check.skattekort': 'Alle medarbejdere har gyldigt skattekort',
  'pay.recon.check.negativ': 'Ingen negative nettobeløb',
  'pay.recon.check.duplikat': 'Mulige dobbeltudbetalinger er identificeret',
  'pay.recon.check.uvanlig': 'Usædvanlige lønændringer er identificeret',
  'pay.recon.check.sluttet': 'Udbetalinger til fratrådte medarbejdere er identificeret',
  'pay.recon.check.naturalytelse': 'Naturalieydelser er analyseret',
  'pay.recon.check.feriepenger': 'Feriepengeforpligtelsen er afstemt',
  'pay.recon.check.termin': 'Skattetræk og arbejdsgiverafgift er afregnet',
  'pay.creatingRun': 'Opretter…',
  'pay.pensionPremiumAmount': 'Faktisk pensionspræmie',
  'pay.pensionBankAmount': 'Betalt fra bank',
  'pay.pensionFeeAmount': 'Særskilt gebyr (brutto)',
  'pay.pensionFeeVat': 'Moms af gebyr',
  'pay.pensionFeeAccount': 'Omkostningskonto for gebyr',
  'pay.pensionOverpaymentNotice': 'Differencen bogføres som forudbetaling til pensionsudbyderen på konto 1570.',
  'pay.createLaterCorrection': 'Opret korrektion i senere periode',
  'pay.createCorrection': 'Opret korrektion',
  'pay.laterCorrectionHelp': 'Den oprindelige kørsel bevares. Når korrektionen godkendes, bogføres kun differencen i den nye periode.',
  'pay.correctionCreated': 'Korrektionskørslen er oprettet som kladde.',
  'pay.typeStandard': 'Standard',
  'pay.typeCustom': 'Egen',
  'pay.statusInactive': 'Inaktiv',
  'pay.ruleTag.aga': 'Arb.afg.',
  'pay.ruleTag.tax': 'Skat',
  'pay.ruleTag.holiday': 'Feriep.',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Arbejdsgiverafgiftspligtig',
  'pay.ruleTitle.tax': 'Trækpligtig',
  'pay.ruleTitle.holiday': 'Feriepengegrundlag',
  'pay.ruleTitle.pension': 'Pensionsgrundlag',
  'pay.stdType.monthly-salary': 'Fast løn',
  'pay.stdType.hourly': 'Timeløn - ikke overarbejde',
  'pay.stdType.overtime-hourly': 'Timeløn - overarbejde',
  'pay.stdType.commission-pay': 'Honorar, akkord, procent- eller provisionsløn',
  'pay.stdType.bonus-holiday-pay': 'Bonus, feriepengeberettiget',
  'pay.stdType.bonus-no-holiday-pay': 'Bonus, ikke feriepengeberettiget',
  'pay.stdType.board-fee': 'Bestyrelseshonorar',
  'pay.stdType.company-car': 'Fri bil',
  'pay.stdType.other-benefits': 'Andre goder',
  'pay.stdType.taxable-insurance': 'Forsikringer, skattepligtig del',
  'pay.stdType.car-km-allowance': 'Kilometergodtgørelse',
  'pay.stdType.car-km-allowance-taxable': 'Kilometergodtgørelse, trækpligtig del',
  'pay.stdType.holiday-pay-current': 'Feriepenge optjent i indeværende år',
  'pay.stdType.holiday-pay-previous': 'Feriepenge optjent tidligere år',
  'pay.stdType.pension-premium': 'Pensionspræmie OTP',
  'pay.stdType.canteen-deduction': 'Kantinetræk',
  'pay.stdType.holiday-deduction': 'Løntræk for ferie',
  'pay.stdType.extra-tax-deduction': 'Ekstra skattetræk',
  'pay.stdType.employee-expense-settlement': 'Udlægsrefusion rejse',
  'pay.stdType.overnight-diet-hotel': 'Diæter ved overnatning',
});
